<app-base-modal [isOpen]="isOpen" (close)="onClose()">
  <h1 header>Attention!</h1>

  <div class="delete-fax-folder-modal">
    <div class="delete-fax-folder-modal__header">
      <h2 class="delete-fax-folder-modal__title">You are deleting folder</h2>

      <p class="delete-fax-folder-modal__subtitle">
        {{ folderName }}
      </p>
    </div>

    <p>Are you sure?</p>

    <div class="delete-fax-folder-modal__footer">
      <button class="btn_secondary btn_sm" (click)="onClose()">No</button>
      <button class="btn_primary btn_sm" (click)="onSubmitClick()">Yes</button>
    </div>
  </div>
</app-base-modal>
